const config = {
    API_DOMAIN: process.env.REACT_APP_API_URL,
    WEB_APP: process.env.REACT_APP_WEB_APP_DOMAIN
};

export default config;
